webpackJsonp([33212578467737],{

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feathr-0.16fcf69d.png";

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feathr-1.0f7d288c.jpg";

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feathr-2.0d9e1d95.jpg";

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feathr-3.96015293.jpg";

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feathr-4.a02f3549.jpg";

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feathr-5.38c2b3d5.jpg";

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feathr-6.cf622353.jpg";

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feathr-7.7692d1df.jpg";

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feathr-icon.373f356f.jpg";

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feathr-site-800.2f69395e.jpg";

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feathr-web-1.4084339b.jpg";

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feathr-web-2.50042617.png";

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feathr-web-3.c2e52a56.png";

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/whiteboard.70930c47.jpeg";

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _jake = __webpack_require__(50);
	
	var _jake2 = _interopRequireDefault(_jake);
	
	var _BackNav = __webpack_require__(15);
	
	var _BackNav2 = _interopRequireDefault(_BackNav);
	
	var _FooterRainbow = __webpack_require__(26);
	
	var _FooterRainbow2 = _interopRequireDefault(_FooterRainbow);
	
	var _feathr = __webpack_require__(484);
	
	var _feathr2 = _interopRequireDefault(_feathr);
	
	var _feathr3 = __webpack_require__(485);
	
	var _feathr4 = _interopRequireDefault(_feathr3);
	
	var _feathr5 = __webpack_require__(486);
	
	var _feathr6 = _interopRequireDefault(_feathr5);
	
	var _feathr7 = __webpack_require__(487);
	
	var _feathr8 = _interopRequireDefault(_feathr7);
	
	var _feathr9 = __webpack_require__(488);
	
	var _feathr10 = _interopRequireDefault(_feathr9);
	
	var _feathr11 = __webpack_require__(489);
	
	var _feathr12 = _interopRequireDefault(_feathr11);
	
	var _feathr13 = __webpack_require__(490);
	
	var _feathr14 = _interopRequireDefault(_feathr13);
	
	var _feathr15 = __webpack_require__(491);
	
	var _feathr16 = _interopRequireDefault(_feathr15);
	
	var _feathrIcon = __webpack_require__(492);
	
	var _feathrIcon2 = _interopRequireDefault(_feathrIcon);
	
	var _feathrSite = __webpack_require__(493);
	
	var _feathrSite2 = _interopRequireDefault(_feathrSite);
	
	var _feathrWeb = __webpack_require__(494);
	
	var _feathrWeb2 = _interopRequireDefault(_feathrWeb);
	
	var _feathrWeb3 = __webpack_require__(495);
	
	var _feathrWeb4 = _interopRequireDefault(_feathrWeb3);
	
	var _feathrWeb5 = __webpack_require__(496);
	
	var _feathrWeb6 = _interopRequireDefault(_feathrWeb5);
	
	var _whiteboard = __webpack_require__(497);
	
	var _whiteboard2 = _interopRequireDefault(_whiteboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Feathr images
	var Feathr = function Feathr() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'main work-page relative' },
	      _react2.default.createElement(_BackNav2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'huge-text col-sm-12' },
	          'Feathr'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement(
	            'p',
	            { className: 'lead' },
	            'Feathr began as a replacement to paper business cards. Do you remember what it\' like to go to a conference, get a pocket full of business cards, and never end up making meaningful connections with most of those people? Feathr organized and made it easy to share your contact information simply.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'lead' },
	            'We ran into the classic \'chicken and egg\' problem - but had great success sponsoring events - so we pivoted into the events space. We sponsored events and even spun out white-labeled conference apps. '
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'lead' },
	            'Designed apps for iOS, Android, inbound marketing website, admin dashboard, and all marketing and communications design. Led the product and team in all aspects of design.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-12' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: _feathr2.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-12' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: _feathr4.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-6' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: _whiteboard2.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-6' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: _feathr14.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-12' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: _feathr10.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-12' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: _feathrIcon2.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-6' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: _feathr12.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-6' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: _feathr14.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-6' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: _feathr8.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-6' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: _feathr16.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-12' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          ' Website Redesign '
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'lead' },
	          'Generated leads and explained the usefulness of the app for event atendees, organizers, and sponsors.'
	        )
	      ),
	      _react2.default.createElement('img', { className: 'img-responsive shadow', src: _feathrSite2.default }),
	      _react2.default.createElement(
	        'p',
	        { className: 'lead' },
	        'As the platform for events evolved, we needed a dashboard for organizers to create and edit events online:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-12' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: _feathrWeb2.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6' },
	          _react2.default.createElement('img', { className: 'img-responsive', src: _feathrWeb4.default })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-6' },
	          _react2.default.createElement('img', { className: 'img-responsive', src: _feathrWeb6.default })
	        )
	      )
	    ),
	    _react2.default.createElement(_FooterRainbow2.default, null)
	  );
	};
	
	exports.default = Feathr;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-feathr-js-e0ea69fd17ea7914c319.js